import { CartItem } from './CartItem'
import { CartItemProps } from '@graphcommerce/magento-cart-items'
import { ConfigurableCartItemFragment } from '@graphcommerce/magento-product-configurable/ConfigurableCartItem/ConfigurableCartItem.gql'
import { OptionsList } from '@graphcommerce/magento-product-configurable/ConfigurableCartItem/OptionsList'

export function ConfigurableCartItem(props: ConfigurableCartItemFragment & CartItemProps) {
  const {
    configurable_options,
    configurable_customizable,
    configured_variant,
    product,
    ...cartItemProps
  } = props
  return (
    <CartItem
      {...cartItemProps}
      product={{
        ...product,
        name: configured_variant?.name ?? product.name,
        thumbnail: configured_variant?.thumbnail ?? product.thumbnail,
      }}
      withOptions
    >
      <OptionsList configurable_options={configurable_options} />
    </CartItem>
  )
}
